<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.browse {
  background-color: #0d86ff;
  color: white;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
</style>

<template>
  <div class="card pb-3">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
     Edit Sertifikasi
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Edit</div> -->
    <form id="form-data" @submit.prevent="postData">
      <div class="card-body">
        <!-- Form Tambah Sertifikasi -->

        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Sertifikasi</div>
          <div class="card-body" id="coba">
            <!-- <form> -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kode" class="font-weight-bold">Kode Sertifikasi</label>
                <input
                  type="text"
                  class="form-control"
                  id="kode"
                  required
                  v-model="formData.kodeSertifikasi"
                  placeholder="Masukkan Kode Sertifikasi"
                  readonly
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Nama Sertifikasi</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama"
                  required
                  v-model="formData.namaSertifikasi"
                  placeholder="Masukkan Nama Sertifikasi"
                />
                <span class="text-danger" v-if="formData.namaSertifikasi.length > 100">
                  *Nama Sertifikasi tidak dapat melebihi 100 karakter
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6" id="divlevel">
                <label for="level" class="font-weight-bold">Level Sertifikasi</label>
                <multiselect
                  label="namaLevel"
                  placeholder="Pilih Nama Level"
                  @input="(value) => updateSelect(value)"
                  v-model="modelLevelPeruntukan"
                  required
                  :options="levelPeruntukan"
                  :loading="loadingLevel"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="model_error.invalid_level">
                  Level Harus Dipilih.
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="biaya" class="font-weight-bold">Biaya Pendaftaran</label>
                <vue-autonumeric
                  required
                  class="form-control"
                  value="0"
                  :options="{
                    minimumValue: '0'
                }"
                  v-model="formData.hargaPendaftaran"
                ></vue-autonumeric>
              </div>
              
            </div>
            <div class="form-row">
              <div class="form-group col-md-12" id="deskripsi">
                <label for="level" class="font-weight-bold">Deskripsi</label>
                <textarea 
                class="form-control"
                v-model="formData.deskripsi"
                required
                name="" 
                id="" 
                cols="30" 
                rows="10"></textarea>
              </div>
              
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Tambah Sertifikasi -->

        <!-- Form Mata Uji -->
        <div class="card border-0 shadow p-2" id="divmatauji">
          <div class="card-header bg-white text-muted h4">Daftar Mata Ujian</div>
          <div class="card-body">
            <div v-for="(input, k) in formData.masterMataUjiRequest" :key="k">
              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="mata_uji" class="font-weight-bold">Mata Ujian</label>                      
                  <multiselect
                    label="namaMataUji"
                    placeholder="Pilih Mata Uji"
                    v-model="input.modelMultiSelect"                    
                    @input="(value) => pilihMataUji(value, k)"
                    @remove="(value) => onRemoveMataUji(value, k)"
                    :options="mataUji"
                  ></multiselect>
                  <div 
                      class="text-danger" 
                      v-if="input.invalid_mata_uji">
                      Mata Uji Harus Dipilih.
                    </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="biaya" class="font-weight-bold">Biaya Mata Uji</label>
                  <vue-autonumeric
                    required
                    class="form-control"
                    value="0"
                    :options="{
                      minimumValue: '0'
                    }"
                    v-model="input.biayaMataUji"
                  ></vue-autonumeric>
                </div>
              
                <div class="col-1 d-flex align-items-center mt-2">
                  <div
                    class="btn btn-sm btn-success ml-2"
                    @click="add(k)"
                    v-show="k == formData.masterMataUjiRequest.length-1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2"
                    @click="(value) => remove(value, k)"
                    v-show="k || ( !k && formData.masterMataUjiRequest.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
        <!-- End Form Mata Uji -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divdokumen">
          <div class="card-header bg-white text-muted h4">Dokumen Persyaratan</div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input,k) in formData.dokumenPendukungSertifikasis"
              :key="k"
            >
              <div class="form-group col-md-6">
                <label for="kode_dok" class="font-weight-bold">Nama Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumen(value,k)"
                  @remove="(value) => onRemoveDokumenPendukung(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="input.invalid_dokumen">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>
              <div class="form-group col-md-5">
                <label for="nama_dok" class="font-weight-bold">Status Dokumen</label>
                
                <select 
                  class="form-control"
                  v-model="input.statusRequired"
                  required
                  style="height: 42px"

                >
                  <option value="1">Wajib</option>
                  <option value="0">Tidak Wajib</option>
                </select>
              </div>
              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok(k)"
                  v-show="k == formData.dokumenPendukungSertifikasis.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="(value) => remove_dok(value, k)"
                  v-show="k || ( !k && formData.dokumenPendukungSertifikasis.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- Form Dokumen persyaratan sertifikat -->
        <div class="card border-0 shadow p-2" id="divpenerbitan">
          <div class="card-header bg-white text-muted h4">Dokumen Persyaratan Sertifikat</div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input,k) in formData.dokumenPersyaratanSertifikat"
              :key="k"
            >
              <div class="form-group col-md-6">
                <label for="nama_dok" class="font-weight-bold">Nama Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumenPenerbitan(value,k)"
                  @remove="(value) => onRemoveDokumenPersyaratan(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="input.invalid_dokumen">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>
              <div class="form-group col-md-5">
                <label for="nama_dok" class="font-weight-bold">Status Dokumen</label>
                
                <select 
                  class="form-control"
                  v-model="input.statusRequired"
                  required
                  style="height: 42px"

                >
                  <option value="1">Wajib</option>
                  <option value="0">Tidak Wajib</option>
                </select>
              </div>
              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok_sertifikat(k)"
                  v-show="k == formData.dokumenPersyaratanSertifikat.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="(value) => remove_dok_sertifikat(value, k)"
                  v-show="k || ( !k && formData.dokumenPersyaratanSertifikat.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Dokumen persyaratan sertifikat -->

        <CCol sm="12">
          <label for class="font-weight-bold">Status Sertifikasi</label>
          <br />
          <div class="d-flex align-items-center">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                value="1"
                required
                v-model="formData.status"
                name="customRadio"
                id="aktif"
                checked
              />
              <label class="custom-control-label" for="aktif">Aktif</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                value="0"
                required
                v-model="formData.status"
                name="customRadio"
                id="tidak_aktif"
              />
              <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
            </div>
          </div>
        </CCol>
        <!-- End Form Dokumen Upload -->
      </div>
      <div class="card-footer bg-white border-0 mb-3 mr-3 mb-3">
        <Button
          class="btn btn-md btn-success px-4 py-2 float-right"
          type="submit"
          color="success"
        >Simpan</Button>
      </div>
    </form>
  </div>
</template>
<script>
import LevelService from "../../../services/datamaster/level.service";
import SertifikasiService from "../../../services/sertifikasi/master-sertifikasi.service";
import MasterMataUjiService from "../../../services/sertifikasi/mata-uji.service";
import AutoNumeric from "../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";
import baseUrl from "../../../services/base-url";

import { MasterDokumen } from "../../../mixins/master/MasterDokumen";
import { AlertUtils } from "../../../mixins/AlertUtils";
import UserGraderService from "../../../services/sertifikasi/user-grader.service"

export default {
  name: 'master-sertifikasi-edit',
  mixins: [MasterDokumen,AlertUtils],
  data() {
    return {
      model_error : {
        invalid_level : false,
      },
      option_grader : [],
      multi_kategori: [
        {
          namaLevel: "",
        },
      ],
      baseUrl: "",
      mataUji: [],

      modelLevelPeruntukan: [],
      levelPeruntukan: [],
      Level: [],

      actionPost: "",

      formData: {
        deskripsi : '',
        masterMataUjiRequest: [
          {
            idMasterMataUji: "",
            idSertifikasiMataUji: "",
            namaMataUji: "",
            deskripsi: "",
            batasNilai: "", // untuk di field
            nilaiMinimum: "", //  untuk ambil response dari API
            invalid_mata_uji : "",
            biayaMataUji : 0,
          },
        ],

        dokumenPendukungSertifikasis: [
          {
            idDokumenPendukung: "",
            idMasterDokumenPendukung: "",
            modelMultiSelect: [],
            invalid_dokumen : false,
            statusRequired : ''
          },
        ],

        dokumenPersyaratanSertifikat: [
          {
            idDokumenPendukung: "",
            idMasterDokumen: "",
            modelMultiSelect: [],
            invalid_dokumen : false,
            statusRequired : ''
          },
        ],

        biayaPerMataUji: "0",
        namaSertifikasi: "",
        hargaPendaftaran: "0",
        kodeSertifikasi: "",
        status: "",

        idLevelAnggota: "",
        namaLevel: "",
        levelPeruntukan: "",

        deleteDokumenPendukung: [],
        deleteDokumenPenerbitan: [],
        deleteMataUji: [],

        loadingLevel: false,
      },
    };
  },

  components: {
    VueAutonumeric,
  },

  mounted() {
    var vm = this;
    vm.baseUrl = baseUrl();
    vm.getLevel();
    vm.getDataPetugasGrader();
    vm.getMataUji();
    vm.getAllDokumen();
    vm.getDetailSertifikasi();
  },

  updated: function () {
    // this.$nextTick(function () {
    //   var vm = this;
    //   vm.isiBatasNilai();
    // });
  },

  methods: {
    getDataPetugasGrader(){
      UserGraderService.getUserGrader(0,1000000000,'default')
      .then(response => {
        // comment console console.log("INI DATA PETUGAS GRADER")
        // comment console console.log(response)
        this.option_grader = response.data.data.content
      }).catch(error => {
        // comment console console.log(error)
      })
    },    
        
    isiBatasNilai() {
      var vm = this;
      /* Fungsi ini untuk menampilkan batas nilai ke form batas nilai */
      for (let i = 0; i < vm.formData.masterMataUjiRequest.length; i++) {
        /* Mengisi Nilai minimum ke BatasNilai berdasarkan index */
        vm.formData.masterMataUjiRequest[i].batasNilai =
          vm.formData.masterMataUjiRequest[i].nilaiMinimum;

        document.getElementById("batas_nilai" + i).value =
          vm.formData.masterMataUjiRequest[i].batasNilai;
        // comment console console.log(vm.formData.masterMataUjiRequest[i].nilaiMinimum);
      }
    },

    add(index) {
      this.formData.masterMataUjiRequest.push({
        mata_uji: "",
        keterangan: "",
        idSertifikasiMataUji: "",
        nilai: "",
        graderSatu : "",
        graderDua : "",
        biayaMataUji : 0,
        invalid_mata_uji : false,
      });
    },    
        
    pilihMataUji(event, k) {
      if(
        this.formData.masterMataUjiRequest[k].idSertifikasiMataUji === ""
        || this.formData.masterMataUjiRequest[k].idSertifikasiMataUji === undefined        
      ) {
        if(event.idMasterMataUji != null) {
          this.formData.masterMataUjiRequest[k].invalid_mata_uji = false
        }

        var data = event.idMasterMataUji
        var status = 0
        for (let index = 0; index < this.formData.masterMataUjiRequest.length; index++) {
          var idMasterMataUji = this.formData.masterMataUjiRequest[index].idMasterMataUji;
          var idSelectMataUji = data;

          if (idMasterMataUji == idSelectMataUji) {
            this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
            status = 1
            // this.formData.masterMataUjiRequest[k].modelMultiSelect = []       
            return false;            
          }
        }
        if(status == 0) {
          this.formData.masterMataUjiRequest[k].modelMultiSelect = event;
          this.formData.masterMataUjiRequest[k].idMasterMataUji = data;
        }
      } else if(this.formData.masterMataUjiRequest[k].idMasterMataUji !== event.idMasterMataUji) {
        this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
        this.formData.masterMataUjiRequest[k].modelMultiSelect = []  
        const element = this.mataUji.find(
          el => el.idMasterMataUji === this.formData.masterMataUjiRequest[k].idMasterMataUji
        );                   
        this.formData.masterMataUjiRequest[k].idMasterMataUji = element.idMasterMataUji;
        this.formData.masterMataUjiRequest[k].modelMultiSelect = element
      }
    },    

    onRemoveMataUji(value, index) {
      if(this.formData.masterMataUjiRequest[index].idSertifikasiMataUji === "") {
        const status = 0;

        if(status == 1) {
          this.formData.masterMataUjiRequest[index] = value;
        } else {
          this.formData.masterMataUjiRequest[index].idMasterMataUji = ""
          status = 1;
        }        
      } else {        
        this.remove(value,index);
      }    
    },

    remove(value, index) {      
      const mataUji = this.formData.masterMataUjiRequest[index];
      const idMasterMataUji = mataUji.idMasterMataUji;
      const idSertifikasiMataUji = mataUji.idSertifikasiMataUji;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus Mata Uji ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {                                                           
            SertifikasiService.deleteMataUji(idSertifikasiMataUji)
              .then(response => {                  
                if(response.data.message === "Data Sedang Digunakan Oleh Peserta Lain") {
                  this.alertError(response.data.message)
                } else {
                  this.formData.deleteMataUji.push({
                    "idMasterMataUji": idMasterMataUji,
                    "idSertifikasiMataUji": idSertifikasiMataUji
                  });
                  this.formData.masterMataUjiRequest.splice(index, 1);
                  this.alertSuccess("Mata Uji Berhasil Dihapus")
                }                               
              })
              .catch(error => {            
                this.alertError(error.response.data.message)
              });
          } else {     
            this.formData.masterMataUjiRequest[index].modelMultiSelect = value;            
            this.$swal.fire(
              "Cancelled",
              "Aksi Dibatalkan",
              "error"
            );
          } 
        });        
    },

    add_dok(index) {
      this.formData.dokumenPendukungSertifikasis.push({
        kodeDokumen: "",
        namaDokumen: "",
        contohDokumen: "",
        idDokumenPendukung: "",
        statusRequired : '',
        idMasterDokumenPendukung: "",
        modelMultiSelect: [],
        invalid_dokumen : false,
        fileName: "",
      });      
    },

    pilihDokumen(value, k) {
      if(this.formData.dokumenPendukungSertifikasis[k].idDokumenPendukung === "") {
        if(value.idMasterDokumen != null) {
          this.formData.dokumenPendukungSertifikasis[k].invalid_dokumen = false
        }

        var data = value.idMasterDokumen;
        var status = 0;
        for (
          let index = 0;
          index < this.formData.dokumenPendukungSertifikasis.length;
          index++
        ) {
          var idMasterDokumen = this.formData.dokumenPendukungSertifikasis[index].idMasterDokumenPendukung;

          var idSelectMasterDokumen = data

          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");          
            status = 1
            this.formData.dokumenPendukungSertifikasis[k].modelMultiSelect = []  
            return false;
          }
        }  
        
        if(status == 0) {
          this.formData.dokumenPendukungSertifikasis[k].idMasterDokumenPendukung = value.idMasterDokumen;
        }
      } else if(this.formData.dokumenPendukungSertifikasis[k].idMasterDokumenPendukung !== value.idMasterDokumenPendukung) {
        this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
        this.formData.dokumenPendukungSertifikasis[k].modelMultiSelect = []  
        const element = this.optionMasterDokumen.find(
          el => el.idMasterDokumenPendukung === this.formData.dokumenPendukungSertifikasis[k].idMasterDokumenPendukung
        );                   
        // comment console console.log(element)
        this.formData.dokumenPendukungSertifikasis[k].idMasterDokumenPendukung = element.idMasterDokumen;
        this.formData.dokumenPendukungSertifikasis[k].modelMultiSelect = element
      }
    },    

    onRemoveDokumenPendukung(value, index) {      
      if(this.formData.dokumenPendukungSertifikasis[index].idDokumenPendukung === "") {
        const status = 0;

        if(status == 1) {
          this.formData.dokumenPendukungSertifikasis[index] = value;
        } else {        
          this.formData.dokumenPendukungSertifikasis[index].idMasterDokumenPendukung = ""
          status = 1;
        }        
      } else {
        this.remove_dok(value, index);
      }      
    },

    remove_dok(value, index) {
      const dokumen = this.formData.dokumenPendukungSertifikasis[index];
      const idDokumenPendukung = dokumen.idDokumenPendukung;
      const idMasterDokumenPendukung = dokumen.idMasterDokumenPendukung;
      const statusRequired = dokumen.statusRequired;

      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus dokumen ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {                                            
            SertifikasiService.deleteDokumenPersyaratan(idDokumenPendukung)
              .then(response => {                
                this.formData.deleteDokumenPendukung.push({
                  "idDokumenPendukung": idDokumenPendukung,
                  "idMasterDokumenPendukung": idMasterDokumenPendukung,
                  "statusRequired": statusRequired
                });    
                this.formData.dokumenPendukungSertifikasis.splice(index, 1);
                this.alertSuccess("Dokumen Persyaratan Berhasil Dihapus")
              })
              .catch(error => {
                this.alertError(error.response.data.message)
              });
          } else {
            this.formData.dokumenPendukungSertifikasis[index].modelMultiSelect = value;            
            this.$swal.fire(
              "Cancelled",
              "Aksi Dibatalkan",
              "error"
            );
          }
        });        
    },

    add_dok_sertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.push({
        kodeDokumen: "",
        namaDokumen: "",
        contohDokumen: "",
        idDokumenPendukung: "",
        statusRequired : '',
        idMasterDokumen: "",
        modelMultiSelect: [],
        fileName: "",
        invalid_dokumen : false,
      });      
    },    

    pilihDokumenPenerbitan(value, k) {
      if(this.formData.dokumenPersyaratanSertifikat[k].idDokumenPendukung === "") {
        if(value.idMasterDokumen != null) {
          this.formData.dokumenPersyaratanSertifikat[k].invalid_dokumen = false
        }

        var data = value.idMasterDokumen;
        var status = 0
      
        for (let index = 0; index < this.formData.dokumenPersyaratanSertifikat.length; index++) {

          var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
          var idSelectMasterDokumen = data

          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");          
            status = 1
            this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = []
            return false;
          }
        }  
        
        if(status == 0) {
          this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;
        }
      } else if(this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumenPendukung !== event.idMasterDokumenPendukung) {
        this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
        this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = []  
        const element = this.optionMasterDokumen.find(
          el => el.idMasterDokumen === this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen
        );              
        // comment console console.log(element)    
        this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumenPendukung = element.idMasterDokumenPendukung;
        this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = element
      }     
    },

    onRemoveDokumenPersyaratan(value, index) {
      if(this.formData.dokumenPersyaratanSertifikat[index].idDokumenPendukung === "") {        
        const status = 0;

        if(status == 1) {
          this.formData.dokumenPersyaratanSertifikat[index] = value;
        } else {
          this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen = "";
          status = 1;
        }
      } else {
        this.remove_dok_sertifikat(value, index);
      }          
    },    

    remove_dok_sertifikat(value, index) {
      const dokumen = this.formData.dokumenPersyaratanSertifikat[index];
      const idDokumenPendukung = dokumen.idDokumenPendukung;
      const idMasterDokumenPendukung = dokumen.idMasterDokumenPendukung;
      const statusRequired = dokumen.statusRequired;
      const modelMultiSelect = dokumen.modelMultiSelect;      

      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus dokumen ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {                                            
            SertifikasiService.deleteDokumenSertifikat(idDokumenPendukung)
              .then(response => {                
                this.formData.deleteDokumenPenerbitan.push({
                  "idDokumenPendukung": idDokumenPendukung,
                  "idMasterDokumenPendukung": idMasterDokumenPendukung,
                  "statusRequired": statusRequired
                });    
                this.formData.dokumenPersyaratanSertifikat.splice(index, 1);
                this.alertSuccess("Dokumen Sertifikat Berhasil Dihapus")
              })
              .catch(error => {
                this.alertError(error.response.data.message)
              });
          } else {
            this.formData.dokumenPersyaratanSertifikat[index].modelMultiSelect = value;            
            this.$swal.fire(
              "Cancelled",
              "Aksi Dibatalkan",
              "error"
            );
          }
        });              
    },

    getMataUji() {
      var vm = this;
      MasterMataUjiService.getAllMataUji()
        .then((response) => {
          vm.mataUji = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getDetailSertifikasi() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      var vm = this;
      this.loadingLevel = true
      SertifikasiService.getDetailSertifikasi(this.$route.params.id_sertifikasi)
        .then((response) => {
          vm.formData = response.data.singleData;
          vm.formData.biayaPerMataUji = response.data.singleData.biayaPerMataUji;
          vm.formData.hargaPendaftaran = response.data.singleData.hargaPendaftaran;                                                  
          vm.formData.deleteDokumenPendukung = [],
          vm.formData.deleteDokumenPenerbitan = [],
          vm.formData.deleteMataUji = [],
          vm.modelLevelPeruntukan = this.levelPeruntukan.find(el => el.idLevelAnggota === vm.formData.levelPeruntukan)                    
          this.loadingLevel = false
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    getLevel() {
      var vm = this;
      LevelService.getAllLevel()
        .then((response) => {
          vm.levelPeruntukan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      if(event == undefined || event == null || event.idLevelAnggota == undefined || event.idLevelAnggota == null) {
        this.formData.levelPeruntukan = ""
        // comment console console.log("LEVEL KOSONG")
      }
      if(event.idLevelAnggota != null ) {
        this.model_error.invalid_level = false;
        this.formData.levelPeruntukan = event.idLevelAnggota;
      } 
    },

    postData() {
      // /**
      //  * Validasi Level
      //  */
      // if(this.formData.levelPeruntukan == '') {
      //   this.model_error.invalid_level = true;
      //   var container = this.$el.querySelector("#divlevel");
      //   container.scrollIntoView()
      //   return false
      // } 
      
      // /**
      //  * Validasi Mata Uji
      //  */
      // var status_invalid = 0;

      // this.formData.masterMataUjiRequest.filter(function(element, index) {
      //   if(element.idMasterMataUji == '') {
      //     element.invalid_mata_uji = true;
      //     status_invalid += 1;
      //   }  
      // });

      // if(status_invalid > 0) {
      //   var container = this.$el.querySelector("#divmatauji");
      //   container.scrollIntoView()
      //   return false
      // }

      // /**
      //  * Validasi Dokumen
      //  */
      // var status_invalid_dokumen = 0;
      // this.formData.dokumenPendukungSertifikasis.filter(function(element, index) {
      //   if(element.idMasterDokumenPendukung == '') {
      //     element.invalid_dokumen = true;
      //     status_invalid_dokumen += 1;
      //   }  
      // });
     
      // if(status_invalid_dokumen > 0) {
      //   var container = this.$el.querySelector("#divdokumen");
      //   container.scrollIntoView()
      //   return false
      // }

      // /**
      //  * Validasi Dokumen Penerbitan Sertifikat
      //  */
      // var status_invalid_dokumen_penerbitan = 0;
      // this.formData.dokumenPersyaratanSertifikat.filter(function(element, index) {
      //   if(element.idMasterDokumen == '') {
      //     element.invalid_dokumen = true;
      //     status_invalid_dokumen_penerbitan += 1;
      //   }  
      // });
     
      // if(status_invalid_dokumen_penerbitan > 0) {
      //   var container = this.$el.querySelector("#divpenerbitan");
      //   container.scrollIntoView()
      //   return false
      // }
      
      this.putData();
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      // comment console console.log(formData);

      for (
        let index = 0;
        index < formData.masterMataUjiRequest.length;
        index++
      ) {
        // var idMasterMataUji = this.formData.masterMataUjiRequest[index].idMasterMataUji;
        for (
          let indexTwo = index + 1;
          indexTwo < formData.masterMataUjiRequest.length;
          indexTwo++
        ) {
          // // comment console console.log(idMasterMataUji + " -- " +idMasterMataUjiTwo )
          if (
            formData.masterMataUjiRequest[index].idMasterMataUji ==
            formData.masterMataUjiRequest[indexTwo].idMasterMataUji
          ) {
            this.alertError("Tidak Boleh Mata Uji Yang Sama");
            return false;
          }
        }
      }
      
      var vm = this;
      SertifikasiService.putSertifikasi(
        formData,
        this.$route.params.id_sertifikasi
      )
        .then((response) => {
          loader.hide();
          vm.myModal = false;
          vm.alertEditSuccess();
          vm.getDetailSertifikasi();
          vm.$router.push({ path: "/sertifikasi/master-sertifikasi" });
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error.response);
          this.alertError(error.response.data.message);
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });      
      var vm = this;      
      SertifikasiService.putSertifikasi(this.formData, this.formData.idSertifikasi)
        .then((response) => {
          loader.hide();          
          vm.alertEditSuccess();          
          vm.$router.push({ path: "/sertifikasi/master-sertifikasi" });          
        })
        .catch((error) => {
          loader.hide();          
          vm.alertError(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
